<template><section><h1>checkbox 复选框</h1>
<h2 id="dai-ma-yan-shi"><a class="header-anchor" href="#dai-ma-yan-shi">¶</a> 代码演示</h2>

<h3 id="ji-chu-ying-yong"><a class="header-anchor" href="#ji-chu-ying-yong">¶</a> 基础应用</h3>

      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;com-checkbox v-model=\&quot;value1\&quot;&gt;点赞&lt;/com-checkbox&gt;\n&quot;,&quot;script&quot;:&quot;\n    export default {\n        data () {\n            return {\n                value1: false\n            }\n        }\n    }\n&quot;,&quot;style&quot;:null}">
        <div class="source" slot="source"><com-checkbox v-model="value1">点赞</com-checkbox>
</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">com-checkbox</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value1"</span>&gt;</span>点赞<span class="hljs-tag">&lt;/<span class="hljs-name">com-checkbox</span>&gt;</span>
</code></pre>
<pre v-pre><code v-pre class="language-js">&lt;script&gt;
    <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
        data () {
            <span class="hljs-keyword">return</span> {
                <span class="hljs-attr">value1</span>: <span class="hljs-literal">false</span>
            }
        }
    }
&lt;<span class="hljs-regexp">/script&gt;
</span></code></pre>
</div></demo-block>
<h3 id="jin-yong-fu-xuan-kuang"><a class="header-anchor" href="#jin-yong-fu-xuan-kuang">¶</a> 禁用复选框</h3>

      <demo-block class="demo-box" :jsfiddle="{&quot;html&quot;:&quot;&lt;com-checkbox v-model=\&quot;value2\&quot; disabled&gt;&lt;/com-checkbox&gt;\n&quot;,&quot;script&quot;:&quot;\n    export default {\n        data () {\n            return {\n                value2: true\n            }\n        }\n    }\n&quot;,&quot;style&quot;:null}">
        <div class="source" slot="source"><com-checkbox v-model="value2" disabled></com-checkbox>
</div>
        
        <div class="hljs highlight" slot="highlight">
    <pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">com-checkbox</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value2"</span> <span class="hljs-attr">disabled</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">com-checkbox</span>&gt;</span>
</code></pre>
<pre v-pre><code v-pre class="language-js">&lt;script&gt;
    <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
        data () {
            <span class="hljs-keyword">return</span> {
                <span class="hljs-attr">value2</span>: <span class="hljs-literal">true</span>
            }
        }
    }
&lt;<span class="hljs-regexp">/script&gt;
</span></code></pre>
</div></demo-block>
<h3 id="props"><a class="header-anchor" href="#props">¶</a> Props</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
<th>是否必填</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td>复选框的值，可用<code v-pre>v-model</code></td>
<td>Boolean</td>
<td>true/false</td>
<td>false</td>
<td>yes</td>
</tr>
<tr>
<td>disabled</td>
<td>是否禁用复选框</td>
<td>Boolean</td>
<td>true/false</td>
<td>false</td>
<td>no</td>
</tr>
</tbody>
</table>
<h3 id="events"><a class="header-anchor" href="#events">¶</a> events</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>改变复选框值触发</td>
<td>新值</td>
</tr>
</tbody>
</table>
</section></template>

<script>
    export default {
        data () {
            return {
                value1: false,
                value2: true
            }
        }
    }
</script>